<template>
    <div>
      <loading ref="loading"></loading>
      <div class="profile_page" id="profile_page" v-if="isAlreadyLoading">
          <Header ref="height"></Header>
          <div class="profile_banner" id="profile_banner">
              <img src="@/assets/images/profile_banner.jpg">
              <div class="profile_avatar">
                  <img :src="profile.avatarImage">
              </div>
          </div>
          <div class="profile_info" id="profile_info">
              <h2 class="customer_name_section" id="customer_name">{{profile.nativeLastName}}{{profile.nativeFirstName}}</h2>
              <div class="customer_level_section" v-bind:style="{ color: customer_level}">
                  <h3 class="customer_level_section_left" v-bind:style="{ color: customer_level}">{{profile.nativeMemberShipLevel}}</h3>
                  <h3 class="customer_level_section_right">{{profile.loyaltyId}}</h3>
              </div>
              <div class="customer_credit">
                  <p>可兑换</p>
                  <p class="exchangeable_points">{{changedPoints}} 积分</p>
              </div>
          </div>
          <div class="profile_level" v-bind:style="{ height: profile_level_height }">
              <div class="progress_bar" v-bind:class="`${profile.memberShipLevel}`" v-bind:style="{ height: progress_bar_height }">
                  <div class="progress_title" v-bind:style="{ backgroundColor: customer_level}">
                      <span>{{year}}年可计入晋级的积分及房晚</span>
                  </div>
                  <div class="points_balance" v-bind:class="{ test: isAnimationStart}">
                      <label class="points_balance_label"><a v-bind:style="{ color: customer_level}">{{profile.pointsEarned}}</a></br>积分</label>
                      <loadingprogress :progress="`${pointsPercent}`" :width="117.5" :height="117.5" :size="117.5" shape="M 105, 105 m -72.5, 0 a 52.5,52.5 0 1 1 52.5,0"/></loadingprogress>
                  </div>
                  <div class="progress_bar_split">
                      <span class="spilt" v-bind:style="{ color: customer_level}"><a class="spilt_text">或</a></span>
                  </div>
                  <div class="nights_balance" v-bind:class="{ test: isAnimationStart}">
                      <label class="nights_balance_label"><a v-bind:style="{ color: customer_level}">{{profile.nightsEarned}}</a></br>房晚</label>
                      <loadingprogress :progress="`${nightsPercent}`" :width="117.5" :height="117.5" :size="117.5" shape="M 105, 105 m -72.5, 0 a 52.5,52.5 0 1 1 52.5,0"/></loadingprogress>
                  </div>
                  <div class="points_to_next_tier">
                      <p class="next_level">{{profile.statusMessage}}</p>
                      <p>{{profile.tierStatusDescription}}</p>
                  </div>
              </div>
          </div>
          <!-- <div class="customer_card_section" id="customer_card_section">
              <button class="weui-btn"><img src="@/assets/images/wechat_card.png">领取微信会员卡</button>
          </div> -->
      </div>
    </div>
</template>

<script>
import { getCustomerInfo, getWXconfig, createCardSig, getCsrfToken } from '@/api/index';
import { formatComma } from '../alias/utils'
import { setStorage, getStorage, deleteStorage } from '@/alias/store';
import Header from '@/components/Header';
import loading from '@/components/loading';
import loadingprogress from '@/components/loadingprogress';
import Vue from "vue";
import MtaH5 from 'mta-h5-analysis';
const wx = require('weixin-js-sdk');

export default {
  name: 'App',
  components: {
    Header,
    loading,
    loadingprogress
  },
  data(){
    return {
      profile_level_height: '',
      progress_bar_height: '',
      isAlreadyLoading: false,
      profile: {},
      changedPoints: '',
      year: '',
      customer_level: '',
      isAnimationStart: false,
      pointsPercent: 0,
      nightsPercent: 0
    }
  },
  methods: {
    getUserInfo: async function() {
      let customer_profile;
      
      if(this.$route.params.userProfile) {
          customer_profile = await this.$route.params.userProfile;
          this.profile = this.$route.params.userProfile;
          if(this.$route.params.isFromSignin) {
            MtaH5.clickStat('signin_success_to_profile')
          }
      } else {
          let parm = {
            'ssoTokenInfoData' : JSON.parse(getStorage('ssoToken')),
            'wxMpUser': JSON.parse(sessionStorage.getItem('userInfo'))
          }
          let csrfToken = await getCsrfToken();
          customer_profile = await getCustomerInfo(parm, csrfToken);
          if(customer_profile.statusCode === 101){
            this.$confirm(`${JSON.stringify(customer_profile.message)}`, '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              center: true,
              showCancelButton: false,
              showClose: false,
            }).then(() => {
              window.location.href= customer_profile.redirectUrl;
            }).catch(() => {
              window.location.href= customer_profile.redirectUrl;
            })
          } else if(customer_profile.statusCode === 102) {

            deleteStorage('ssoToken');
            // deleteStorage('userInfo');
            window.location.href = customer_profile.redirectUrl;
          } else {
            MtaH5.clickStat("token_to_profile");
            this.profile = customer_profile.data.memberProfileData;
            let ssoToken = customer_profile.data.ssoTokenInfoData;
            setStorage('ssoToken', JSON.stringify(ssoToken));
          }
      }
      this.year = this.profile.levelExpirationDate.substring(0,4);
      this.changePointsFormat();
      this.setColor();
      this.isAlreadyLoading = true;
      document.getElementById("loading").style.display = 'none';
      this.$refs.loading.isLoading = false;
    },
    setColor() {
      switch(this.profile.memberShipLevel){
        case this.profile.memberShipLevel = "CLUB":
          this.customer_level = '#ce5426';
          break;
        case this.profile.memberShipLevel = "GOLD":
          this.customer_level = '#85754e';
          break;
        case this.profile.memberShipLevel = "PLATINUM":
          this.customer_level = '#818183';
          break;
        case this.profile.memberShipLevel = "SPIRE":
          this.customer_level = '#a82328';
          break;
        case this.profile.memberShipLevel = "ROYAL":
          this.customer_level = '#000000';
          break;
        default:
        this.customer_level = '#000';
          break;
      }
    },
    changePointsFormat() {
      this.changedPoints = this.profile.pointsBalance.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    },
    getConfig: async function() {
      let persentUrl = window.location.href;
      let param = { "currentUrl" : persentUrl };
      let res = await getWXconfig(param);
      this.WXconfig = res.data;
      await wx.config({
        debug: false,
        appId: res.data.appId,
        timestamp: res.data.timestamp,
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        jsApiList:['addCard','openCard']
      })
    },
    addCard: async function() {
      let signature = await createCardSig();
      let Sign = signature.data.signature;
      let Time = signature.data.timestamp;
      let RandomStr = signature.data.nonceStr;
      wx.addCard({
        cardList: [
          {
            cardId: "p6pqU04gpjeJvvmnOw0LVPkf5SJE",
            cardExt: {"timestamp": Time,"signature": Sign,"nonce_str": RandomStr,"outer_str":"123"}
          }
        ],
        success: function (res) {
          alert('已添加卡券：' + JSON.stringify(res.cardList));
        }
      })
    }
  },
  created(){
    this.getUserInfo();
  },
  mounted(){
    MtaH5.pgv();
    MtaH5.clickStat('sintosuptopro',{'profilepage':'true'});
    MtaH5.clickStat('signintoprofile',{'profilepage':'true'});
    if(document.getElementById("loading").style.display === 'block') {
        this.$refs.loading.isLoading = false;
    } else {
        this.$refs.loading.isLoading = true;
    }
    this.getConfig();
    let that = this;
    window.addEventListener("popstate", function(e) {
        let len = window.history.length;
        window.history.go(1-len);
    }, false);
  },
  updated() {
    var body_height = document.getElementById("profile_page").offsetHeight;
    var device_height = document.documentElement.clientHeight;
    let header_height = this.$refs.height.headerHeight;
    // var member_card_height = document.getElementById("customer_card_section").offsetHeight;
    var profile_banner = document.getElementById("profile_banner").offsetHeight + 60;
    var profile_info = document.getElementById("profile_info").offsetHeight;
    if(device_height > body_height){
      this.profile_level_height = (device_height - header_height - profile_banner - profile_info - 12 + 8) + 'px';
      this.progress_bar_height = (device_height - header_height - profile_banner - profile_info - 12) + 'px';
    }
    this.pointsPercent = this.profile.pointsPercentage;
    this.nightsPercent = this.profile.nightsPercentage;
    this.isAnimationStart = true;
  }
}
</script>

<style scope lang="sass">
.test
  .vue-progress-path
    path
      transition: stroke-dashoffset 2000ms ease-in-out;
      -webkit-transition: stroke-dashoffset 2000ms ease-in-out;
      -moz-transition: stroke-dashoffset 2000ms ease-in-out;
.CLUB
  .vue-progress-path .background
    stroke: #ce5426;

.GOLD
  .vue-progress-path .background
    stroke: #85754e;

.PLATINUM
  .vue-progress-path .background
    stroke: #818183;

.SPIRE
  .vue-progress-path .background
    stroke: #a82328;

.ROYAL
  .vue-progress-path .background
    stroke: #000000;
html, body
  .profile_page
    background: #efefef;
    .profile_banner
        margin-bottom: 40px;
        font-size: 0;
        position: relative;
        img
            width: 100%;
            height: 120px;
    .profile_avatar
        position: absolute;
        text-align: center;
        right: 0;
        left: 0;
        bottom: -36px;
        img
            width: 80px;
            height: 80px;
            border-radius: 50%;
    .profile_info
      line-height: 28px;
      text-align: center;
      .customer_name_section
        font-size: 22px;
      .customer_level_section
        width: 100%;
        height: 25px;
        display: inline-block;
        position: relative;
        .customer_level_section_left
          font-size: 16px;
        .customer_level_section_right
          font-size: 16px;
        .divider
          position: absolute;
          width: 10px;
          height: 28px;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
      .customer_credit
        p
          font-size: 16px;
        .exchangeable_points
          font-size: 22px;
          color: #d16a32;
    .profile_level
      height: 290px;
      margin-top: 25px;
      .progress_title
        position: absolute;
        width: 80%;
        height: 35px;
        text-align: center;
        color: #ffffff;
        left: 0;
        right: 0;
        margin: auto;
        top: -18px;
        span
          font-size: 18px;
          line-height: 35px;
      .progress_bar
        position: relative;
        height: 282px;
        margin: 8px;
        background: #ffffff;
        .progress_bar_split
          text-align: center;
          padding-top: 35px;
          .spilt:before,.spilt:after
            content: "";
            display: block;
            height: 45px;
            width: 1px;
            border-style: solid;
            border-width: 0 0 0 1px;
            margin: 5px auto
          .spilt_text
            color: #000;
        .vue-progress-path
          .progress
            stroke: #f3f4ec;
        .points_balance
          position: absolute;
          top: 45px;
          left: 10%;
          @media screen and (max-width: 350px)
            left: 5%;
          path
            stroke-width: 10px;
          .points_balance_label
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            text-align: center;
            margin: 0;
            -webkit-transform: translate(0,-50%);
            transform: translate(0,-50%);
        .nights_balance
          position: absolute;
          top: 45px;
          right: 10%;
          @media screen and (max-width: 350px)
            right: 5%;
          path
            stroke-width: 10px;
          .nights_balance_label
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            text-align: center;
            margin: 0;
            -webkit-transform: translate(0,-50%);
            transform: translate(0,-50%);
        .points_to_next_tier
          padding: 10px 15px 0;
          text-align: center;
          .next_level
            color: #bcbcbc;
.customer_card_section
  padding: 30px 0;
  margin: 0;
  img
    height: 16px;
    margin-right: 10px;
    vertical-align: -2px;
  .weui-btn
      width: 60%;
      font-size: 16px;
      border-radius: 20px;
      background: #d16a32;
.el-message-box
  width: 70% !important;
.el-message-box__wrapper
  z-index: 999999 !important;
</style>



// WEBPACK FOOTER //
// src/views/Profile.vue